import React, { useState } from 'react'
import $t from '../../../../i18n'
import { useDispatch, useSelector } from 'react-redux'
import Actions from '../../../../actions'
import Page from '../../../common/Page/Page'
import ActionButton from '../../../common/ActionButton'
import { isNil } from 'ramda'
import { event, eventTypes } from '../../../../consts/eventConsts'
import { isBotIntentChronic } from '../../../../utils/hmoUtils'

import './DoctorSelectPage.css'

export const DoctorSelectPage = ({ onNext }) => {
  const dispatch = useDispatch()
  const hmoSelectedIntent = useSelector(
    state => state.getCare.hmoSelectedIntent
  )
  const [isDesignated, setIsDesignated] = useState()

  const isChronicSelected = isBotIntentChronic(hmoSelectedIntent)

  const onDoctorSelected = designated => {
    setIsDesignated(designated)
    dispatch(Actions.createAction(Actions.DOCTOR_SELECTED, { designated }))

    dispatch(
      Actions.createAction(Actions.ANALYTICS_EVENT_FIRED, {
        type: eventTypes.formEvent,
        eventName: event.formEvent.submit,
        data: { designated },
        element: Actions.DOCTOR_SELECTED,
      })
    )

    // on next comes from wizard component
    // we can use this component without the wizard and and 'onnext' will be undefined
    if (onNext) {
      onNext({ designated })
    }
  }

  return (
    <Page
      title={$t('doctorSelectPage.title')}
      subtitle={isChronicSelected ? $t('doctorSelectPage.subtitle') : null}
    >
      <div className="doctor-page-container">
        <ActionButton
          label={$t('doctorSelectPage.any')}
          iconName="Clinicians"
          isVertical
          size={40}
          className="any-action doctor-action"
          data-selected={!isNil(isDesignated) && !isDesignated}
          onPress={() => onDoctorSelected(false)}
        />
        <ActionButton
          label={$t('doctorSelectPage.myDoctor')}
          iconName="profile"
          isVertical
          size={40}
          className="personal-action doctor-action"
          data-selected={isDesignated}
          onPress={() => onDoctorSelected(true)}
        />
      </div>
    </Page>
  )
}

export default DoctorSelectPage
